module.exports = __webpack_public_path__ + "static/og-567b3ff783ec646700c594305495a893.png";